import { Question, Segment } from "hp-types";

const checkNOGFilter = (NOGFilter: boolean, question: Question) => {
  return NOGFilter ? true : question.segment !== Segment.NOG;
};

export default checkNOGFilter;
